import { render, staticRenderFns } from "./switchWithLabel.vue?vue&type=template&id=0d1b6f48&scoped=true"
import script from "./switchWithLabel.vue?vue&type=script&lang=js"
export * from "./switchWithLabel.vue?vue&type=script&lang=js"
import style0 from "./switchWithLabel.vue?vue&type=style&index=0&id=0d1b6f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1b6f48",
  null
  
)

export default component.exports